export default {
	INPUT_PLACEHOLDER: 'Filter data...',
	LEGACY_FILTER: 'Legacy'
};
